export default __webpack_public_path__ + "static/media/user-placeholder.efe1b491.svg";